<template>
  <div id="sbsDetail" class="mainContainer" v-loading="loading" style="padding-top: 20px;">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/Home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/sbsda' }">手把手教你做资料</el-breadcrumb-item>
      <el-breadcrumb-item>{{infoData.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div id="danganConts" class="danganConts"></div>
    <div class="fileList">
      <div class="fjxz">附件:</div>
      <div v-for="(item,i) in fileList" class="fjlist" @click="upload(item)"><img
          src="@/assets/images/lianjie.png" />{{item.fileName}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Notice',
    props: ['wjSrc', 'currentUser'],
    data() {
      return {
        params: {
          page: 1,
          rows: 50
        },
        infoData: {},
        loading: true,
        fileList: []
      }
    },
    methods: {
      getDetail: function() {
        this.loading = true;
        this.$axios.get('/kt/ktZjfwInfo/nolDetail.htm?id=' + sessionStorage.getItem('daid'), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.infoData = data.data;
          document.getElementById('danganConts').innerHTML = data.data.conts;
          this.loading = false;
        })
      },
      getFileList: function() {
        this.loading = true;
        this.$axios.get('/file/attachment/nollist.htm?page=1&rows=20&dataId=&bType=zxktda&bId=' + sessionStorage
          .getItem('daid'), {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
          var data = res.data;
          var fileList = data.rows;
          var arr = [];
          var na = []
          fileList.map((item) => {
            var a = [];
            if (item.fileName.indexOf('：') >= 0) {
              a = item.fileName.split('：')[0].split('附件');
            } else {
              a = item.fileName.split('.')[0].split('附件');
            }
            var num = 0;
            if (a.length > 1) {
              num = Number(a[1]) - 1;
              arr[num] = item
            } else {
              na.push(item)
            }
          });
          var b = arr.concat(na);
          console.log(na, arr)
          this.fileList = b;
          this.loading = false;
        })
      },
      upload(file) {
        // 判断是否登录
        if (this.currentUser) {
          // 若已登录,直接下载
          window.open('/jtzy' + file.filePath)
        } else {
          this.$confirm('您还未登录，请先进行登录！若无账号，请先进行注册！', '提示', {
              distinguishCancelAndClose: true,
              confirmButtonText: '去登录',
              cancelButtonText: '去注册'
            })
            .then(() => {
              this.$router.push('/Login')
            })
            .catch(action => {
              this.$router.push('/Register')
            });
        }
      }
    },
    created: function() {
      this.getDetail();
      this.getFileList()
    }
  }
</script>

<style>
  body {
    background-color: #fff;
  }

  #sbsDetail {
    width: 1000px;
  }

  .danganConts {
    box-shadow: 0 4px 15px 0 rgb(0 0 0 / 10%);
    padding: 30px;
    background: #fff;
    /* width: 1000px; */
    margin: 40px auto;
  }

  .danganConts p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  .danganConts .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
  }

  .fjlist {
    color: rgb(13, 110, 253);
    /* text-align: right; */
    text-decoration: underline;
    font-size: 14px;
    cursor: pointer;
    padding: 5px 0;
  }

  .fjxz {
    font-weight: 800;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sbsDetail.vue